import { Fragment, type ReactNode } from 'react'

export const ListWithOxfordComma = ({
  items,
  conjunction = 'and',
}: {
  items: ReactNode[]
  conjunction?: string
}) => {
  if (!items || items.length === 0) {
    return null
  }

  if (items.length === 1) {
    return <>{items[0]}</>
  }

  if (items.length === 2) {
    return (
      <>
        {items[0]} {conjunction} {items[1]}
      </>
    )
  }

  return (
    <>
      {items.slice(0, -1).map((item, index) => (
        <Fragment key={index}>
          {item}
          {', '}
        </Fragment>
      ))}
      {conjunction} {items[items.length - 1]}
    </>
  )
}
